import { adminApi } from '../../../lib/admin-api/index.js';

export function callsRequest(token, path, method = 'GET', body) {
  return adminApi.requestAdmin({ token, path: `/admin/calls${path}`, method, body });
}
